(function(){
  function updateCartCount(count){
    var link=document.querySelector('.aa-global-cart');
    if(!link)return;
    var bubble=link.querySelector('.aa-global-cart__count');
    if(count>0){
      if(!bubble){bubble=document.createElement('span');bubble.className='aa-global-cart__count';link.appendChild(bubble)}
      bubble.textContent=String(count);
    }else if(bubble){bubble.remove()}
  }

  function init(root){
    if(!root||root.dataset.realCartReady==='true')return;
    root.dataset.realCartReady='true';
    var form=root.closest('form');
    var status=root.querySelector('[data-tumbler-cart-status]');
    if(!form)return;

    form.addEventListener('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      if(!form.checkValidity()){form.reportValidity();return}

      var button=form.querySelector('[ref="addToCartButton"]');
      if(button)button.disabled=true;
      if(status){status.hidden=false;status.dataset.state='working';status.textContent='Agregando tu tumbler al carrito…'}

      var formData=new FormData(form);
      fetch('/cart/add.js',{
        method:'POST',
        body:formData,
        headers:{Accept:'application/json'},
        credentials:'same-origin'
      })
      .then(function(response){
        return response.json().then(function(data){
          if(!response.ok||data.status){throw new Error(data.description||data.message||'No se pudo agregar el producto al carrito.')}return data
        })
      })
      .then(function(){return fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})})
      .then(function(response){return response.json()})
      .then(function(cart){
        updateCartCount(cart.item_count||0);
        if(status){status.hidden=false;status.dataset.state='success';status.textContent='✓ Agregado al carrito. Tu foto y los detalles se guardaron con este producto.'}
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));
      })
      .catch(function(error){
        console.error('[Ashanart tumbler cart]',error);
        if(status){status.hidden=false;status.dataset.state='error';status.textContent=error.message||'No se pudo agregar al carrito. Inténtalo otra vez.'}
      })
      .finally(function(){if(button)button.disabled=false});
    },true);
  }

  function initAll(){document.querySelectorAll('[data-tumbler-personalization]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
